/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
} from "@angular/common/http";
import {CustomHttpParameterCodec} from "../encoder";
import {Observable} from "rxjs";

import {VersionCreateReleaseDto} from "../model/models";
import {VersionCreateSnapshotDto} from "../model/models";
import {VersionDto} from "../model/models";

import {BASE_PATH, COLLECTION_FORMATS} from "../variables";
import {Configuration} from "../configuration";
import {VersionControllerBackendServiceInterface} from "./versionController.serviceInterface";

@Injectable({
  providedIn: "root",
})
export class VersionControllerBackendService implements VersionControllerBackendServiceInterface {
  protected basePath = "http://localhost:8080";
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== "string") {
      if (typeof basePath !== "string") {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === "object" && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === "object") {
      if (Array.isArray(value)) {
        (value as any[]).forEach(
          (elem) => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)),
        );
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substr(0, 10));
        } else {
          throw Error("key may not be null if value is Date");
        }
      } else {
        Object.keys(value).forEach(
          (k) =>
            (httpParams = this.addToHttpParamsRecursive(
              httpParams,
              value[k],
              key != null ? `${key}.${k}` : k,
            )),
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error("key may not be null if value is not object or array");
    }
    return httpParams;
  }

  /**
   * @param snapshotVersionId
   * @param versionCreateReleaseDto
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createReleaseVersion(
    snapshotVersionId: number,
    versionCreateReleaseDto: VersionCreateReleaseDto,
    observe?: "body",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: "application/json"},
  ): Observable<number>;
  public createReleaseVersion(
    snapshotVersionId: number,
    versionCreateReleaseDto: VersionCreateReleaseDto,
    observe?: "response",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: "application/json"},
  ): Observable<HttpResponse<number>>;
  public createReleaseVersion(
    snapshotVersionId: number,
    versionCreateReleaseDto: VersionCreateReleaseDto,
    observe?: "events",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: "application/json"},
  ): Observable<HttpEvent<number>>;
  public createReleaseVersion(
    snapshotVersionId: number,
    versionCreateReleaseDto: VersionCreateReleaseDto,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {httpHeaderAccept?: "application/json"},
  ): Observable<any> {
    if (snapshotVersionId === null || snapshotVersionId === undefined) {
      throw new Error(
        "Required parameter snapshotVersionId was null or undefined when calling createReleaseVersion.",
      );
    }
    if (versionCreateReleaseDto === null || versionCreateReleaseDto === undefined) {
      throw new Error(
        "Required parameter versionCreateReleaseDto was null or undefined when calling createReleaseVersion.",
      );
    }

    let headers = this.defaultHeaders;

    let credential: string | undefined;
    // authentication (OAuth) required
    credential = this.configuration.lookupCredential("OAuth");
    if (credential) {
      headers = headers.set("Authorization", "Bearer " + credential);
    }

    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ["application/json"];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ["application/json"];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    let responseType: "text" | "json" = "json";
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith("text")) {
      responseType = "text";
    }

    return this.httpClient.post<number>(
      `${this.configuration.basePath}/v1/versions/${encodeURIComponent(String(snapshotVersionId))}/release`,
      versionCreateReleaseDto,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * @param baseVersionId
   * @param versionCreateSnapshotDto
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createSnapshotVersion(
    baseVersionId: number,
    versionCreateSnapshotDto: VersionCreateSnapshotDto,
    observe?: "body",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: "application/json"},
  ): Observable<number>;
  public createSnapshotVersion(
    baseVersionId: number,
    versionCreateSnapshotDto: VersionCreateSnapshotDto,
    observe?: "response",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: "application/json"},
  ): Observable<HttpResponse<number>>;
  public createSnapshotVersion(
    baseVersionId: number,
    versionCreateSnapshotDto: VersionCreateSnapshotDto,
    observe?: "events",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: "application/json"},
  ): Observable<HttpEvent<number>>;
  public createSnapshotVersion(
    baseVersionId: number,
    versionCreateSnapshotDto: VersionCreateSnapshotDto,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {httpHeaderAccept?: "application/json"},
  ): Observable<any> {
    if (baseVersionId === null || baseVersionId === undefined) {
      throw new Error(
        "Required parameter baseVersionId was null or undefined when calling createSnapshotVersion.",
      );
    }
    if (versionCreateSnapshotDto === null || versionCreateSnapshotDto === undefined) {
      throw new Error(
        "Required parameter versionCreateSnapshotDto was null or undefined when calling createSnapshotVersion.",
      );
    }

    let headers = this.defaultHeaders;

    let credential: string | undefined;
    // authentication (OAuth) required
    credential = this.configuration.lookupCredential("OAuth");
    if (credential) {
      headers = headers.set("Authorization", "Bearer " + credential);
    }

    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ["application/json"];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ["application/json"];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    let responseType: "text" | "json" = "json";
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith("text")) {
      responseType = "text";
    }

    return this.httpClient.post<number>(
      `${this.configuration.basePath}/v1/versions/${encodeURIComponent(String(baseVersionId))}/snapshot`,
      versionCreateSnapshotDto,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * @param versionId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getVersion(
    versionId: number,
    observe?: "body",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: "application/json"},
  ): Observable<VersionDto>;
  public getVersion(
    versionId: number,
    observe?: "response",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: "application/json"},
  ): Observable<HttpResponse<VersionDto>>;
  public getVersion(
    versionId: number,
    observe?: "events",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: "application/json"},
  ): Observable<HttpEvent<VersionDto>>;
  public getVersion(
    versionId: number,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {httpHeaderAccept?: "application/json"},
  ): Observable<any> {
    if (versionId === null || versionId === undefined) {
      throw new Error(
        "Required parameter versionId was null or undefined when calling getVersion.",
      );
    }

    let headers = this.defaultHeaders;

    let credential: string | undefined;
    // authentication (OAuth) required
    credential = this.configuration.lookupCredential("OAuth");
    if (credential) {
      headers = headers.set("Authorization", "Bearer " + credential);
    }

    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ["application/json"];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith("text")) {
      responseType = "text";
    }

    return this.httpClient.get<VersionDto>(
      `${this.configuration.basePath}/v1/versions/${encodeURIComponent(String(versionId))}`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * @param versionId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getVersionModel(
    versionId: number,
    observe?: "body",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: "application/json"},
  ): Observable<object>;
  public getVersionModel(
    versionId: number,
    observe?: "response",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: "application/json"},
  ): Observable<HttpResponse<object>>;
  public getVersionModel(
    versionId: number,
    observe?: "events",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: "application/json"},
  ): Observable<HttpEvent<object>>;
  public getVersionModel(
    versionId: number,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {httpHeaderAccept?: "application/json"},
  ): Observable<any> {
    if (versionId === null || versionId === undefined) {
      throw new Error(
        "Required parameter versionId was null or undefined when calling getVersionModel.",
      );
    }

    let headers = this.defaultHeaders;

    let credential: string | undefined;
    // authentication (OAuth) required
    credential = this.configuration.lookupCredential("OAuth");
    if (credential) {
      headers = headers.set("Authorization", "Bearer " + credential);
    }

    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ["application/json"];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith("text")) {
      responseType = "text";
    }

    return this.httpClient.get<object>(
      `${this.configuration.basePath}/v1/versions/${encodeURIComponent(String(versionId))}/model`,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }

  /**
   * @param versionId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public restoreVersion(
    versionId: number,
    observe?: "body",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: "application/json"},
  ): Observable<number>;
  public restoreVersion(
    versionId: number,
    observe?: "response",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: "application/json"},
  ): Observable<HttpResponse<number>>;
  public restoreVersion(
    versionId: number,
    observe?: "events",
    reportProgress?: boolean,
    options?: {httpHeaderAccept?: "application/json"},
  ): Observable<HttpEvent<number>>;
  public restoreVersion(
    versionId: number,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {httpHeaderAccept?: "application/json"},
  ): Observable<any> {
    if (versionId === null || versionId === undefined) {
      throw new Error(
        "Required parameter versionId was null or undefined when calling restoreVersion.",
      );
    }

    let headers = this.defaultHeaders;

    let credential: string | undefined;
    // authentication (OAuth) required
    credential = this.configuration.lookupCredential("OAuth");
    if (credential) {
      headers = headers.set("Authorization", "Bearer " + credential);
    }

    let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (httpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ["application/json"];
      httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    let responseType: "text" | "json" = "json";
    if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith("text")) {
      responseType = "text";
    }

    return this.httpClient.post<number>(
      `${this.configuration.basePath}/v1/versions/${encodeURIComponent(String(versionId))}/restore`,
      null,
      {
        responseType: <any>responseType,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      },
    );
  }
}
